import React from "react";
import { SelectInput, required } from "react-admin";
import { useWatch } from "react-hook-form";

const SemesterInput = ({ practices = [], source = "semester", readOnly = false }) => {
  const practiceId = useWatch({ name: "practiceId" });
  const semesters = practices.find(practice => practice.id === practiceId)?.semesters ?? [];
  const choices = semesters.filter(semester => semester > 0).map(semester => ({ id: semester, name: semester }));

  return (
    <SelectInput
      source={source}
      label="Семестър"
      choices={choices}
      optionText="name"
      optionValue="id"
      validate={required("Полето е задължително")}
      readOnly={readOnly}
      fullWidth
    />
  );
};

export default SemesterInput;
